import React from "react";
import {InlineTextInput} from "@advthreat/ribbon-components";
import {t} from "i18next";
import {useDispatch, useSelector} from "react-redux";
import {patchIncident} from "store/features/incidentDetailSlice";
import {selectIncidentDetail} from "store/selectors";
import css from "./ShortDescription.module.scss";

// @todo magna-fix Needs correct Edit icon.
const ShortDescription = () => {
  const dispatch = useDispatch();
  const incident = useSelector(selectIncidentDetail);
  const {id: incidentId, short_description} = incident;

  const saveShortDescription = (newValue, {callback}) => {
    dispatch(
      patchIncident({
        incidentId,
        patch: {short_description: newValue}
      })
    );
    callback(true);
  };

  return (
    <div
      className={css.shortDescriptionEditor}
      data-testid={"ShortDescription-Span"}>
      <InlineTextInput
        id="shortDescription"
        name="shortDescription"
        required={true}
        value={short_description?.trim()?.length > 0 ? short_description : null}
        onChange={saveShortDescription}
        preventEmpty={true}
        emptyValue={t("incidentDetail.detail.emptyShortDesc")}
        maxLength={140}
      />
    </div>
  );
};

export default ShortDescription;
